import { alpha, Chip, styled } from '@/shared/ui/mui';
/**
 * PriceChip - A purple-tinted chip for displaying prices
 *
 * Features:
 * - Light purple background with transparency
 * - Purple text from theme
 * - Bold font weight
 * - No border, no shadow
 * - Perfect for pricing displays, cost indicators
 *
 * Usage:
 * ```tsx
 * <PriceChip label="$25" />
 * <PriceChip label="From $20" />
 * ```
 */
export const PriceChip = styled(Chip)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  boxShadow: 'none',
  border: 'none',
}));
